/* global $, I18n */
/* eslint-disable prefer-arrow-callback, strict */

(function init() {
  const SPACE_KEY = 32;
  var submitTimeout = null; // eslint-disable-line

  $(function onReady() {
    // eslint-disable-line
    // Even though autofocus is used on this element, we must trigger it with
    // jQuery as well, so that Mixer can react to its being focused and add the
    // 'is-filled' class.
    $('#emailInput').focus();
    // both fields do not exist together hence we are fine here
    $('#midInput').focus();
  });

  function resetForm() {
    // $('#messageContainer').hide();
    $('#messageContainer').empty();
    $('#spinnerContainer').empty();
  }

  function showSpinner() {
    $('#spinnerContainer').append($('<span/>').addClass('mx-spinner-ring'));
  }

  function pleaseWaitWhileLoading() {
    $('#messageContainer').append(
      $('<span/>').addClass('mx-alert-notify').html(I18n.t('js.modules.app.login.waitWhileLoading'))
    );
  }

  function onSubmit(form) {
    resetForm();
    $(form).find('.submitButton').hide();
    showSpinner();
    form.submit();
    clearTimeout(submitTimeout);
    submitTimeout = setTimeout(pleaseWaitWhileLoading, 3000);
  }

  function onValidationError(event, validator) {
    const errors = validator.numberOfInvalids();
    if (errors) {
      $('#spinnerContainer').empty();
      $(this).find('.submitButton').show();
    }
  }

  // MINSKY-130: Prevent spaces from being entered in the email field, which
  // causes validation issues in Firefox.
  $('#emailInput').on({
    keydown(event) {
      if (event.which === SPACE_KEY) {
        event.preventDefault();
      }
    },
    // Handle change events too (for the case of copy-pasting)
    change() {
      this.value = this.value.replace(/\s/g, '');
    },
  });

  function forgotPasswordSubmit(form) {
    const $form = $(form);
    resetForm();
    $form.find('.submitButton').hide();
    showSpinner();
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      useJqXHR: true,
    })
      .done(function done() {
        $('#messageContainer')
          .append(
            $('<span/>')
              .addClass('mx-alert-success')
              .html(
                I18n.t('js.modules.app.forgotPasswordForm.success.instructions', {
                  emailAddress: $form.find('[name="email"]').val(),
                })
              )
          )
          .show();
        $form.hide(100);
        $('#gotoLogin').show();
      })
      .fail(function fail(resp) {
        let message = I18n.t('js.modules.app.forgotPasswordForm.fail.generalError', {
          newLine: '<br/>',
        });
        if (resp.status === 400) {
          message = I18n.t('js.modules.app.forgotPasswordForm.fail.canNotFindAccount');
        }
        $('#messageContainer').append($('<span/>').addClass('mx-alert-error').html(message)).show();
      })
      .always(function always() {
        $('#spinnerContainer').empty();
        $('#forgotPasswordForm .submitButton').show();
      });
  }

  $('#loginForm').validate({
    rules: {
      email: {
        required: true,
        email: true,
      },
      password: {
        required: true,
      },
    },
    onfocusout: false,
    errorPlacement: function errorPlacement() {},
    submitHandler: onSubmit,
    invalidHandler: onValidationError,
  });

  $('#forgotPasswordForm').validate({
    rules: {
      email: {
        required: true,
        email: true,
      },
    },
    onfocusout: false,
    errorPlacement: $.noop,
    submitHandler: forgotPasswordSubmit,
    invalidHandler: onValidationError,
  });

  $('#merchantSelectForm').validate({
    rules: {
      mid: {
        required: true,
      },
    },
    onfocusout: false,
    errorPlacement: $.noop,
    submitHandler: onSubmit,
    invalidHandler: onValidationError,
  });
})();

/* eslint-enable prefer-arrow-callback, strict */
